import styled from 'styled-components'

export const SIZE = 48

export const StyledAvatarContainer = styled.div`
  width: ${SIZE}px;
  height: ${SIZE}px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  cursor: pointer;
  font-weight: 600;
  line-height: 24;
  color: ${({ theme }) => theme.headerLogin.avatar.color};
  border: 1px solid ${({ theme }) => theme.headerLogin.avatar.borderColor};

  &:hover {
    border: 1px solid orange;
    color: ${({ theme }) => theme.headerLogin.icon.hover.color};

    path {
      fill: ${({ theme }) => theme.headerLogin.icon.hover.color};
    }

    > * {
      cursor: pointer;
    }
  }
`
